import { Component, Input, OnInit } from '@angular/core'

import {
  DEFAULT_PRODUCT_TYPE,
  SESSION_STORAGE_CONSTANTS_CAAS_CONTENT,
} from '../../../../constants/constant.content'
import { NUMBER_ONE, NUMBER_ZERO } from '../../../../constants/constant.numbers'
import { ObservableService } from '../../../services/observable-service/observable.service'
import { AssetClassModel } from '../../../shared/asset-class-model'
import { FilterModel } from '../../../shared/filter-model'

@Component({
  selector: 'applied-filter',
  templateUrl: './applied-filter.component.html',
  styleUrls: ['./applied-filter.component.scss'],
})
export class AppliedFilterComponent implements OnInit {
  @Input() isShowFilters: boolean
  productType: any
  filterBy: any
  appliedFiltersPrdct: any
  appliedFiltersFilterByLevel1 = []
  isShowFiltersContainer = false
  filterByList: Array<string> = [
    'equity',
    'fixedIncome',
    'multiAsset',
    'cashEquivalent',
    'factorDriven',
    'esg',
    'sectorSpecialties',
    'dividend',
  ]
  fd3ContentGenericListResponse: any
  defaultProductType = DEFAULT_PRODUCT_TYPE
  constructor(
    private filterModel: FilterModel,
    private observableService: ObservableService,
  ) {}
  ngOnInit() {
    const aemCassDataFromSession = sessionStorage.getItem(
      SESSION_STORAGE_CONSTANTS_CAAS_CONTENT,
    )
    const parsedCaasJson = JSON.parse(aemCassDataFromSession)
    this.fd3ContentGenericListResponse =
      parsedCaasJson.data.fd3genericList.items[0]
    this.filterModel.telecastProductType.subscribe((data: any) => {
      this.productType = data
      this.isShowFiltersContainer = this.getShowFilterContainerVisible()
      this.appliedFiltersPrdct = this.appliedFiltersProduct(this.productType)
    })
    this.filterModel.telecastFilterBy.subscribe((data: any) => {
      this.filterBy = data
      this.isShowFiltersContainer = this.getShowFilterContainerVisible()
      this.appliedFiltersFilterByLevel1 = this.appliedFiltersFilterBy(
        this.filterBy,
      )
    })
  }

  getShowFilterContainerVisible(): boolean {
    return (
      this.productType.productType.mf.value ||
      this.productType.productType.etf.value ||
      this.productType.productType.colTrust.value ||
      (this.filterBy && this.filterBy.isFilterByLevel1Clicked)
    )
  }

  appliedFiltersProduct(productType: any) {
    let tempProduct: any
    if (productType.isProductTypeClicked) {
      for (const value in productType.productType) {
        if (productType.productType[value].value) {
          tempProduct = productType.productType[value]
        }
      }
      return tempProduct
    }
  }

  appliedFiltersFilterBy(filterBy: any) {
    let tempFilterBy: any
    if (filterBy.isFilterByLevel1Clicked) {
      for (const value in filterBy.filterByLevel1) {
        if (filterBy.filterByLevel1[value].value) {
          tempFilterBy = filterBy.filterByLevel1[value]
        }
      }
      return tempFilterBy
    }
  }

  clearAllFilter() {
    this.filterModel.clearAllFilter()
    this.setFocusToBenchMark()
  }

  // eslint-disable-next-line complexity,max-statements
  removeAppliedFilterChipAction(args: any[]) {
    let removedItem = ''
    args.forEach((obj) => {
      if (obj.isClosed) removedItem = obj.labelText
    })
    const productTypeArray = []
    Object.values(this.productType.productType).forEach((obj) => {
      productTypeArray.push(obj['text'])
    })
    const filterByArray = []
    Object.values(this.filterBy.filterByLevel1).forEach((obj) => {
      filterByArray.push(obj['text'])
    })
    const subAssetArray = []
    Object.values(this.filterBy.filterByLevel1).forEach((obj) => {
      if (obj['value'] && obj['level2'] !== undefined) {
        obj['level2'].forEach((subAsset: { text: any }) => {
          subAssetArray.push(subAsset.text)
        })
      }
    })
    if (productTypeArray.includes(removedItem)) {
      this.filterModel.clearAllFilter()
    } else if (filterByArray.includes(removedItem)) {
      // reset the sub asset selection count to 0
      this.filterModel.setSubAssetSelectedCount(NUMBER_ZERO)
      this.removeFilterByWithSubAsset()
    } else if (subAssetArray.includes(removedItem)) {
      //on removal of chip from sub asset filter, reduce the sub asset selection count by 1
      this.filterModel.setSubAssetSelectedCount(
        this.filterModel.getSubAssetSelectedCount() - NUMBER_ONE,
      )
      this.removeSubAsset(removedItem)
    }

    for (let i = 0; i < args.length; i++) {
      if (i == 0 && args[i].isClosed) {
        this.setFocusToBenchMark()
      } else if (
        args.length > 1 &&
        args[1].isClosed &&
        filterByArray.includes(removedItem)
      ) {
        this.setFocusToClearAll()
      } else if (
        !args[0].isClosed &&
        args[i].isClosed &&
        args[i + 1] != undefined
      ) {
        args[i + 1].elementRef.nativeElement.focus()
      } else if (
        !args[0].isClosed &&
        args[i].isClosed &&
        i === args.length - 1
      ) {
        this.setFocusToClearAll()
      }
    }
  }

  setFocusToBenchMark() {
    const benchMark: HTMLElement = document.querySelector(
      'c11n-checkbox #benchMark',
    )
    if (benchMark) {
      setTimeout(() => {
        benchMark.focus()
      })
    }
  }

  setFocusToClearAll() {
    const clearAllFocus: HTMLElement = document.querySelector(
      '.clear-all-wrapper a',
    )
    if (clearAllFocus) {
      setTimeout(() => {
        clearAllFocus.focus()
      })
    }
  }

  removeFilterByWithSubAsset() {
    const defaultAssetClass = new AssetClassModel()
    this.observableService.viewFilterByClick('')
    this.observableService.filterBySelectedItem({
      inputId: '',
      isSelected: false,
    })
    this.filterModel.editDataFilterBy(defaultAssetClass)
  }

  removeSubAsset(removedItem: string) {
    if (this.filterBy.filterByLevel1.equity.value) {
      this.filterBy.filterByLevel1.equity.level2.forEach(
        (obj: any, index: string | number) => {
          if (obj['text'] === removedItem) {
            this.filterBy.filterByLevel1.equity.level2[index].value = false
          }
        },
      )
    } else if (this.filterBy.filterByLevel1.multiAsset.value) {
      this.filterBy.filterByLevel1.multiAsset.level2.forEach(
        (obj: any, index: string | number) => {
          if (obj['text'] === removedItem) {
            this.filterBy.filterByLevel1.multiAsset.level2[index].value = false
          }
        },
      )
    } else if (this.filterBy.filterByLevel1.fixedIncome.value) {
      this.filterBy.filterByLevel1.fixedIncome.level2.forEach(
        (obj: any, index: string | number) => {
          if (obj['text'] === removedItem) {
            this.filterBy.filterByLevel1.fixedIncome.level2[index].value = false
          }
        },
      )
    } else if (this.filterBy.filterByLevel1.cashEquivalent.value) {
      this.filterBy.filterByLevel1.cashEquivalent.level2.forEach(
        (obj: any, index: string | number) => {
          if (obj['text'] === removedItem) {
            this.filterBy.filterByLevel1.cashEquivalent.level2[index].value =
              false
          }
        },
      )
    }
    this.filterModel.editDataFilterBy(this.filterBy)
  }
}
